import {observer} from "mobx-react-lite";
import React, {useEffect, useState} from "react";
import {FilePondErrorDescription, FilePondFile} from "filepond";
import {useLeadStore} from "../store/Lead.store";
import {SubmitUploadButton, UploadComponent} from "../../form/upload.component";

interface NotesUploadProps
{
    uploadButtonText: string;
    contentText: string;
    theme: string;
}

export const NotesUploadComponent = observer( ( {uploadButtonText, contentText, theme}: NotesUploadProps ) => {
    const [files, setFiles] = useState<FilePondFile[]>( [] )
    const store = useLeadStore();

    const allowedFileTypes = ['image/png', 'image/jpeg', "application/pdf"];

    const onUpdateFiles = ( fileItems: FilePondFile[] ) => {
        const validFileItems = fileItems.filter( value => allowedFileTypes.includes( value.fileType ) );
        setFiles( validFileItems );
    };

    const onRemoveFiles = ( error: FilePondErrorDescription | null, file: FilePondFile ) => {
        const allButRemovedFile = files.filter( item => item != file );
        setFiles( allButRemovedFile );
    };
    useEffect( () => {
        if ( store.notes.uploadedNoteFiles ) {
            setFiles( [] );
        }
    }, [store.notes.uploadedNoteFiles] )

    return (
        <div>
            {store.notes.uploadedNoteFiles && <h4 className={"text-inverted text-uppercase mt-5"}>{store.translate(
                'leadgeneration.steps.confirmationNewConstructionStep.notes.uploaded' )}</h4>}
            {!store.notes.uploadedNoteFiles && <React.Fragment>
                <div>
                    <div className="dashed-border mt-5 ml-5 mr-5">
                        <UploadComponent
                                updateFilesFunction={onUpdateFiles}
                                onRemoveFileFunction={onRemoveFiles}
                                allowedFileTypes={allowedFileTypes}
                                text={contentText}
                        />
                    </div>
                    <div className={"upload-btn-wrapper m-3"}>
                        <SubmitUploadButton
                                uploadFunction={store.uploadNotes}
                                files={files}
                                text={uploadButtonText}
                                theme={theme}
                        />
                    </div>
                </div>
            </React.Fragment>}
        </div>
    );
} )
